import { formatInkDate } from './utils/formatDateTime/formatInkDate';
import { normalizeDate } from './utils/normalizeDate/normalizeDate';

export { LOCALES, LocaleType } from './constants/localeConstants';
export { getResolvedLocale } from './utils/internal/getResolvedLocales';

export { normalizeDate, formatInkDate };

export type { DateDisplayFormat } from './types';
export { extractDateTimeInfo } from './utils/extractDateTime/extractDateTime';
